<script setup>
import { computed } from 'vue'
import { useRoute } from 'vue-router'

const props = defineProps({
    excludeRoutes: {
        type: Array,
        default: () => [],
    },
})

const route = useRoute()
const { y } = useWindowScroll()

// Check if current route should be excluded
const shouldShow = computed(() => {
    return !props.excludeRoutes.includes(route.name)
})

const scrollToTop = () => {
    window.scrollTo({
        top: 0,
        behavior: 'smooth',
    })
}

const scrollToBottom = () => {
    window.scrollTo({
        top: document.body.scrollHeight,
        behavior: 'smooth',
    })
}
</script>

<template>
    <VScaleTransition
        v-if="shouldShow"
        style="transform-origin: right"
        class="scroll-to d-print-none"
    >
        <div v-show="y > 10">
            <div>
                <VBtn
                    icon
                    density="comfortable"
                    class="scroll-to-top"
                    @click="scrollToTop"
                >
                    <VIcon size="8" icon="ucsi-page-up" />
                </VBtn>
            </div>
            <div>
                <VBtn
                    icon
                    density="comfortable"
                    class="scroll-to-bottom"
                    @click="scrollToBottom"
                >
                    <VIcon size="8" icon="ucsi-page-down" />
                </VBtn>
            </div>
        </div>
    </VScaleTransition>
</template>

<style lang="scss">
.scroll-to {
    position: fixed !important;

    // To keep button on top of v-layout. E.g. Email app
    z-index: 999;
    inset-block-end: 45%;
    inset-inline-end: 0px;

    .v-btn {
        border-bottom: 1px solid #1a1a1a;
        background: linear-gradient(90deg, #272626 0%, #4d4d4d 100%);
        border-bottom-width: 1px;
        opacity: 1;
        border-radius: 0;
    }

    .scroll-to-top {
        border-top-left-radius: 8px;
    }

    .scroll-to-bottom {
        border-bottom-left-radius: 8px;
    }
}
</style>
